// Robust way to check if it's Node or browser
export function isServer() {
  return typeof window === 'undefined';
}

export function isBrowser() {
  return !isServer();
}
